import React from 'react';

export const NewArrowUpIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg width="17" height="23" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.2875 11.1363C15.5755 11.8077 14.4768 11.7874 13.7851 11.0956L10.4486 7.75908L10.4486 20.5967C10.4486 21.5936 9.65512 22.387 8.65823 22.387C7.66133 22.387 6.86788 21.5936 6.86788 20.5967L6.86788 7.75908L3.53133 11.0956C2.8396 11.7874 1.74098 11.7874 1.02891 11.1363C0.296498 10.4446 0.276153 9.28495 0.988223 8.57288L8.63788 0.923218L16.2875 8.57288C16.9996 9.28495 16.9793 10.4446 16.2468 11.1363H16.2875Z"
        fill="#005D98"
      />
    </svg>
  );
};
